export class ParametreSocieteModel {

	language: string = 'fr';
	timezone: string = '+0200';
	formatDate: string = 'dd-MM-yyyy';
	formatHeure: string = 'HH:mm';
	nbrDecimal: number = 2;
	symboleMonetaire: string = '€';
	arrondiMontant: number = 2;
}
